/**
 * DENET — muadil ürünler
 *
 * "Aynı işi gören başka marka" — distribütörün pazaryerine karşı asıl
 * üstünlüğü bu. Trendyol'da tek marka görürsün; burada aynı watt ve renk
 * sıcaklığındaki üç seçeneği yan yana görürsün.
 *
 * Eşleştirme etiketlerden: aktarımda her ürüne `36w`, `4000k`, `ip40` gibi
 * etiketler yazıldı. Shopify aramasının `tag:` söz dizimi bunları filtreliyor,
 * böylece Search & Discovery ayarına bağımlı kalmıyoruz.
 *
 * Kademeli daraltma: önce üç ölçüt birden denenir, sonuç yoksa IP düşer,
 * yine yoksa yalnız watt kalır. Boş bir blok göstermektense yakın olanı
 * göstermek daha faydalı — ama hangi ölçütle bulunduğu yazılır.
 */

import { DenetElement, define } from '@denet/core';

class DnEquivalents extends DenetElement {
  async mounted() {
    this.track = this.ref('track');
    this.note = this.ref('note');

    const watt = this.dataset.watt;
    const cct = this.dataset.cct;
    const ip = this.dataset.ip;
    const handle = this.dataset.handle;

    if (!watt || !this.track) {
      this.remove();
      return;
    }

    /* Sırayla gevşeyen ölçüt kümeleri. */
    const attempts = [];
    if (watt && cct && ip) attempts.push([[`tag:${watt}`, `tag:${cct}`, `tag:${ip}`], this.dataset.labelAll]);
    if (watt && cct) attempts.push([[`tag:${watt}`, `tag:${cct}`], this.dataset.labelWattCct]);
    attempts.push([[`tag:${watt}`], this.dataset.labelWatt]);

    for (const [terms, label] of attempts) {
      const html = await this.#fetch(terms, handle);
      if (!html) continue;
      this.track.innerHTML = html;

      /* Kendisi tek sonuçsa muadil yok demektir. */
      if (this.track.querySelectorAll('.dn-pcard').length < 1) continue;

      if (this.note && label) this.note.textContent = label;
      this.hidden = false;
      window.dispatchEvent(new Event('resize'));   // ray oklarını tazele
      return;
    }

    this.remove();
  }

  /**
   * @param {string[]} terms
   * @param {string} exclude
   */
  async #fetch(terms, exclude) {
    const root = window.Shopify?.routes?.root || '/';
    const q = encodeURIComponent(terms.join(' AND '));
    try {
      const res = await fetch(`${root}search?q=${q}&type=product&view=cards`);
      if (!res.ok) return '';
      const html = await res.text();

      /* Ürünün kendisini listeden çıkar: Liquid tarafında handle'ı
         bilemiyoruz, burada DOM'dan ayıklıyoruz. */
      const box = document.createElement('div');
      box.innerHTML = html;
      box.querySelectorAll(`a[href*="/products/${exclude}"]`).forEach((a) => {
        a.closest('.dn-prail__item')?.remove();
      });
      return box.innerHTML.includes('dn-pcard') ? box.innerHTML : '';
    } catch {
      return '';
    }
  }
}

define('dn-equivalents', DnEquivalents);
